export function isContent(question_id, questions, hideBack) {
  if (hideBack) return false

  let prev_question_index =
    questions?.findIndex(item => item === question_id) - 1
  return prev_question_index >= 0
}
